export default (function () {
    return {
        toHtmlEntities: function (originalString) {
            return originalString.replace(/./gm, function(s) {
                return "&#" + s.charCodeAt(0) + ";";
            });
        }
    };
}());